import './anchorblock.less'
import m from 'mithril'
import {Component} from '@codeurs/front'
import slugify from 'slugify'

export type AnchorBlockType = {
	label: string
}

export default class AnchorBlock extends Component<AnchorBlockType> {
	static slugify(navigation_title) {
		return slugify(navigation_title, {
			replacement: '_',
			remove: /[*+~.()\'"!:@?]/g,
			lower: true
		})
	}

	view() {
		const {label} = this.attrs

		return m(`.anchor#${AnchorBlock.slugify(label)}`)
	}
}
